"use strict";

var _toConsumableArray = require("/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.concat = function () {
  for (var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++) {
    arrays[_key] = arguments[_key];
  }

  return arrays.reduce(function (a, b) {
    return Uint8Array.from([].concat(_toConsumableArray(a), _toConsumableArray(b)));
  }, new Uint8Array(0));
};

exports.range = function (start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Array.from({
    length: end - start
  }).map(function (_, i) {
    return i * step + start;
  });
};